import React from "react";
import { Collapse, Drawer, Typography } from "antd";
import type { DataQuestionsCatalog } from "../../store/api/dataQuestionsApi";

interface CatalogDrawerProps {
  open: boolean;
  catalog?: DataQuestionsCatalog;
  onClose: () => void;
}

/** What the model can see: the glossary and every view with its columns. */
export const CatalogDrawer: React.FC<CatalogDrawerProps> = ({
  open,
  catalog,
  onClose,
}) => (
  <Drawer
    title="Qué datos puedo preguntar"
    open={open}
    width={560}
    onClose={onClose}
  >
    {(catalog?.glossary ?? []).length > 0 && (
      <>
        <Typography.Title level={4}>Términos</Typography.Title>
        <ul>
          {(catalog?.glossary ?? []).map((entry) => (
            <li key={entry.term}>
              <Typography.Text strong>{entry.term}:</Typography.Text>{" "}
              {entry.meaning}
            </li>
          ))}
        </ul>
      </>
    )}
    <Typography.Title level={4}>Datos disponibles</Typography.Title>
    <Collapse
      size="small"
      items={(catalog?.views ?? []).map((view) => ({
        key: view.name,
        label: (
          <>
            <Typography.Text code>{view.name}</Typography.Text>{" "}
            <Typography.Text type="secondary">{view.description}</Typography.Text>
          </>
        ),
        children: (
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {view.columns.map((column) => (
              <li key={column.name}>
                <Typography.Text code>{column.name}</Typography.Text>{" "}
                {column.description}
              </li>
            ))}
          </ul>
        ),
      }))}
    />
  </Drawer>
);
